export default {
  methods: {
    formatTiroirName(tiroir) {
      if (tiroir !== undefined) {
        const str = tiroir.replace('TIROIR OPTIQUE EQUIPE DE', '');
        return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
      }
      return '';
    },
  },
};
